<button class="btn btn-sm btn-light" (click)="onUpdateStatus(ruleViolation, ruleStatus.PASSED)"
    [disabled]="disableButtons || ruleViolation.status === ruleStatus.PASSED"
    [ngClass]="{ PASSED: ruleViolation.status === ruleStatus.PASSED }" title="Passed">
    <i class="fas fa-check"
        *ngIf="!(showLoading && ruleWorkFlow.ruleUpdate.status === ruleStatus.PASSED)"></i>
    <div *ngIf="showLoading && ruleWorkFlow.ruleUpdate.status === ruleStatus.PASSED"
        class="loading-wrapper">
        <i class="fas fa-spinner"></i>
    </div>
</button>
<button class="btn btn-sm btn-light" (click)="onUpdateStatus(ruleViolation, ruleStatus.FLAG)"
    [disabled]="disableButtons || ruleViolation.status === ruleStatus.FLAG"
    [ngClass]="{ FLAG: ruleViolation.status === ruleStatus.FLAG }" title="Flag">
    <i class="fas fa-flag"
        *ngIf="!(showLoading && ruleWorkFlow.ruleUpdate.status === ruleStatus.FLAG)"></i>
    <div *ngIf="showLoading && ruleWorkFlow.ruleUpdate.status === ruleStatus.FLAG"
        class="loading-wrapper">
        <i class="fas fa-spinner"></i>
    </div>
</button>
<button class="btn btn-sm btn-light" (click)="onUpdateStatus(ruleViolation, ruleStatus.FAILED)"
    [disabled]="disableButtons || ruleViolation.status === ruleStatus.FAILED"
    [ngClass]="{ FAILED: ruleViolation.status === ruleStatus.FAILED }" title="Failed">
    <i class="fas fa-ban"
        *ngIf="!(showLoading && ruleWorkFlow.ruleUpdate.status === ruleStatus.FAILED)"></i>
    <div *ngIf="showLoading && ruleWorkFlow.ruleUpdate.status === ruleStatus.FAILED"
        class="loading-wrapper">
        <i class="fas fa-spinner"></i>
    </div>
</button>